import React from "react";
import { contactData, closingData } from "../data/mock";
import { Separator } from "./ui/separator";
import { Phone, Mail, Instagram, MessageSquare } from "lucide-react";

const Contact = () => {
  const socialLinks = [
    {
      icon: Phone,
      label: "WhatsApp",
      value: contactData.whatsapp,
      href: contactData.whatsappLink,
      color: "hover:border-emerald-500/50 hover:bg-emerald-500/5",
    },
    {
      icon: Mail,
      label: "Email",
      value: contactData.email,
      href: `mailto:${contactData.email}`,
      color: "hover:border-teal-500/50 hover:bg-teal-500/5",
    },
    {
      icon: Instagram,
      label: "Instagram",
      value: contactData.instagramHandle,
      href: contactData.instagram,
      color: "hover:border-pink-500/50 hover:bg-pink-500/5",
    },
    {
      icon: () => (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.86a8.28 8.28 0 004.76 1.5v-3.4a4.85 4.85 0 01-1-.27z" />
        </svg>
      ),
      label: "TikTok",
      value: contactData.tiktokHandle,
      href: contactData.tiktok,
      color: "hover:border-cyan-500/50 hover:bg-cyan-500/5",
    },
  ];

  return (
    <section id="contact" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-600/30 to-transparent" />
        <div className="absolute bottom-1/3 right-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        {/* Closing quote */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-8">
            <MessageSquare className="w-5 h-5 text-teal-400" />
            <span className="font-nunito text-teal-400 text-sm tracking-[0.25em] uppercase font-semibold">
              Contacto
            </span>
          </div>

          <blockquote className="font-nunito text-xl md:text-2xl text-slate-200 italic max-w-3xl mx-auto mb-4 leading-relaxed">
            "{closingData.quote}"
          </blockquote>
          <p className="font-bebas text-3xl md:text-4xl text-teal-400 tracking-wide">{closingData.closing}</p>
        </div>

        <Separator className="bg-teal-500/10 mb-16" />

        <p className="font-nunito text-center text-slate-200 mb-12">{closingData.cta}</p>

        {/* Social links centered */}
        <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {socialLinks.map((link, idx) => {
            const IconComponent = link.icon;
            return (
              <a
                key={idx}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(link.href, "_blank", "noopener,noreferrer");
                }}
                className={`group flex items-center gap-4 p-5 rounded-xl border border-slate-300/40 backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-teal-500/5 cursor-pointer ${link.color}`}
              >
                <div className="w-12 h-12 rounded-xl bg-slate-200/50 flex items-center justify-center text-black group-hover:text-teal-400 transition-colors duration-300">
                  <IconComponent className="w-5 h-5" />
                </div>
                <div>
                  <span className="font-nunito text-xs text-black uppercase tracking-wider">{link.label}</span>
                  <p className="font-nunito text-slate-100 font-medium">{link.value}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Contact;
